import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = {
  state: () => ({
    userIns: {},
    subheads: {},
    screens: {},
    customScreeners: [],
    selectedScreener: {
      slug: "BASIC",
      name: "New Screen",
      custom: false
    },
    snackbar: {
      show: false,
      timeout: 10000,
      color: "success",
      message: null,
      onStateChange: false
    }
  }),
  mutations: {
    setUser(state, user) {
      state.userIns = user;
    },
    setSubheads(state, subheads) {
      for (const key in subheads) {
        subheads[key].filters.sort((i, j) => {
          if (i.ordinal > j.ordinal) return 1;
          if (j.ordinal > i.ordinal) return -1;
          return 0;
        });
      }
      state.subheads = subheads;
    },
    setScreens(state, screens) {
      state.screens = screens;
    },
    setCustomScreeners(state, customScreeners) {
      state.customScreeners = customScreeners;
    },
    setScreener(state, screener) {
      state.selectedScreener = screener;
    },
    showSnackbar(state, settings) {
      state.snackbar = {
        show: true,
        timeout: 3000,
        color: settings.color || "success",
        message: settings.message || "",
        onStateChange: settings.onStateChange || false
      };
    },
    hideSnackbar(state) {
      state.snackbar = {
        show: false,
        message: ""
      };
    }
  },
  actions: {
    async fetchUser({ commit }) {
      return Vue.http.get("/getUser").then(function (success) {
        commit("setUser", success.body)
        console.log("fetch user done")
      }).catch(function (e) {
        console.log(e)
      })
    },
    fetchSubheads({ commit }) {
      Vue.http.get("/filter/subheads").then(function (success) {
        commit("setSubheads", success.body)
      }).catch(function (e) {
        console.log(e)
      })
    },
    fetchScreens({ commit }) {
      Vue.http.get("/reports").then(function (success) {
        commit("setScreens", success.body)
      }).catch(function (e) {
        console.log(e)
      })
    },
    fetchCustomScreeners({ commit }) {
      Vue.http.get("/customScreeners").then(function (success) {
        commit("setCustomScreeners", success.body)
      }).catch(function (e) {
        console.log(e)
      })
    },
  },
  getters: {
    user(state) {
      return state.userIns;
    },
    level(state) {
      return state.userIns.level;
    },
    isPremiumUser(state) {
      return state.userIns.level === "Plus" || state.userIns.level === "Full";
    },
    isExportAllowed(state) {
      return state.userIns.level === "Plus" || state.userIns.level === "Full" ||
        state.userIns.level === "Trial";
    },
    subheads(state) {
      return state.subheads;
    },
    screens(state) {
      return state.screens;
    },
    getCustomScreeners(state) {
      return state.customScreeners;
    },
    getScreenerId(state) {
      return state.selectedScreener.slug || "BASIC";
    },
    screener(state) {
      return state.selectedScreener;
    },
    getSessionId(state) {
      return state.userIns.token
    }
  }
}

export default new Vuex.Store(store);
